import LinkRoutes, {
    CategorieItem,
} from "../../components/navigation/LinkRoutes";
import { useTranslation } from "react-i18next";
import { routes } from "../../routes";
const TablePage = () => {
    const { t } = useTranslation();

    const categories: CategorieItem[] = [
        {
            title: t("table.locationManagement"),
            links: [
                {
                    name: t("table.company.company"),
                    path: routes.tableRoute.companyEdit,
                },
                {
                    name: t("table.property.propertyGroups"),
                    path: routes.tableRoute.propertyGroups,
                },
                {
                    name: t("table.building.buildings"),
                    path: "/table/location/buildings",
                },
                {
                    name: t("table.floor.floors"),
                    path: routes.tableRoute.floors,
                },

                {
                    name: t("table.profile.profiles"),
                    path: routes.tableRoute.profiles,
                },
                {
                    name: t("table.local.locals"),
                    path: routes.tableRoute.locals,
                },
                {
                    name: t("table.route.routes"),
                    path: routes.tableRoute.routes,
                },
                {
                    name: t("table.task.tasks"),
                    path: routes.tableRoute.tasks,
                },
                {
                    name: t("table.user.users"),
                    path: routes.tableRoute.users,
                },
                {
                    name: t("table.contact.contacts"),
                    path: routes.tableRoute.contacts,
                },
            ],
        },
    ];

    return <LinkRoutes categories={categories} />;
};

export default TablePage;
